import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { toast } from "react-toastify";

import { ButtonBase, InputAutoresize } from "../../../common/components/form";
import Wait from "../Wait";
import * as API from "../../lib/api";

export default function WebsiteAnalytics() {
    const { t } = useTranslation();
    const { id } = useParams();

    const history = useHistory();

    const [wait, setWait] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [project, setProject] = React.useState([]);

    const [prevProjectJson, setPrevProjectJson] = React.useState("");

    React.useEffect(() => {
        id && Load(id);
    }, [id]);

    function Load(id_project) {
        setLoading(true);
        return API.Send("/project/get", { id_project })
            .then(project => {
                if (!project?.ok) {
                    return;
                }

                setProject(project || []);

                setPrevProjectJson(JSON.stringify(project));
            })
            .finally(() => setLoading(false));
    }

    function onAnalyticsChange({ target: { name, value } }) {
        const { variables } = project;
        variables[name] = value;
        setProject({ ...project, variables });
    }

    function onCancelClick() {
        history.goBack();
    }

    function onSaveClick() {
        setWait(true);
        API.CompileUpdateProject({ ...project, id_project: project.id })
            .then(() => history.goBack())
            .catch(e => {
                for (const error of e) {
                    toast.error(t(error.error));
                }
            })
            .finally(() => setWait(false));
    }

    const codeHead = project?.variables?.codeHead || "";
    const codeBody = project?.variables?.codeBody || "";

    const allowSave = prevProjectJson !== JSON.stringify(project);

    return (
        <>
            <div className="website-settings analytics">
                {loading && <h2 className="panel-heading-text">{t("Loading")}...</h2>}

                {!loading && project && (
                    <>
                        <h2 className="panel-heading-text">{t("AnalyticsIntegration")}</h2>

                        <div className="website-settings-fields">
                            <div>
                                <InputAutoresize
                                    multirow
                                    name="codeHead"
                                    value={codeHead || ""}
                                    placeholder={t("HEADTagCodeCanBeInsertHere")}
                                    style={{ minHeight: "144px", fontFamily: "monospace" }}
                                    onChange={onAnalyticsChange}
                                />
                            </div>

                            <div>
                                <InputAutoresize
                                    multirow
                                    name="codeBody"
                                    value={codeBody || ""}
                                    placeholder={t("BODYTagCodeCanBeInsertHere")}
                                    style={{ minHeight: "144px", fontFamily: "monospace" }}
                                    onChange={onAnalyticsChange}
                                />
                            </div>
                        </div>

                        <div className="website-settings-actions">
                            <ButtonBase solid onClick={() => onCancelClick()}>
                                {t("Cancel")}
                            </ButtonBase>

                            <ButtonBase invert onClick={() => onSaveClick()} disabled={!allowSave}>
                                {t("Save")}
                            </ButtonBase>
                        </div>
                    </>
                )}
            </div>

            <Wait show={wait} />
        </>
    );
}
